export interface MonthlyPaymentStatus {
  athlete_id: string
  athlete_name: string
  is_paid: boolean
  paid_at?: string
  /** На паузе, но за месяц оплатил */
  is_paused?: boolean
}

export interface GroupMonthlyPayments {
  group_id: string
  year_month: string
  monthly_price?: number // kopecks
  total_count: number
  paid_count: number
  /** С кого берём оплату; по ним считаются total_count и paid_count */
  athletes: MonthlyPaymentStatus[]
  /** На паузе и не оплатили: в отчёт не входят, но отметить можно */
  paused?: MonthlyPaymentStatus[]
}

export function formatMonthlyPrice(kopecks: number): string {
  return `${(kopecks / 100).toLocaleString('ru-RU')} ₽`
}

const MONTH_NAMES: Record<string, string> = {
  '01': 'Январь', '02': 'Февраль', '03': 'Март',
  '04': 'Апрель', '05': 'Май', '06': 'Июнь',
  '07': 'Июль', '08': 'Август', '09': 'Сентябрь',
  '10': 'Октябрь', '11': 'Ноябрь', '12': 'Декабрь',
}

export function formatYearMonth(yearMonth: string): string {
  const [year, month] = yearMonth.split('-')
  return `${MONTH_NAMES[month] || month} ${year}`
}

export function getCurrentYearMonth(): string {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
}

export function shiftMonth(yearMonth: string, delta: number): string {
  const [year, month] = yearMonth.split('-').map(Number)
  const date = new Date(year, month - 1 + delta, 1)
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
}
